import React, { Component } from "react";
import AWS_S3 from 'aws-sdk/clients/s3';

import { S3_BUCKET_NAME, IMAGE_SIZE_LIMIT_BYTES, VIDEO_SIZE_LIMIT_BYTES, MIN_DESKTOP_WIDTH } from '../../constants';
import { EXERCISE_VIDEO_INSTRUCTIONS } from '../../static-content';
import PreviewVideo from './PreviewVideo';
import { withRouter } from "react-router-dom";
import { AlertJsMessage } from './../../helpers.js'

const acceptTypes = {
  profile: 'image/*',
  explainer: 'video/mp4',
  exercise: 'video/mp4'
}
class UploadForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      previewImageSrc: '',
      fileCategory: 'profile',
      previewVideoSrc: '',
      isMobile: window.innerWidth < MIN_DESKTOP_WIDTH ? true : false,
      fileLoaded: false,
      isUploading: false
    }
  }
  submit(){
    this.setState({
      ...this.state,
      isUploading: true
    });
    const s3 = new AWS_S3({
      apiVersion: '2006-03-01',
      params: {Bucket: S3_BUCKET_NAME}
    });
    const { history } = this.props;
    const file = this.uploadInput.files[0];
    if (file) {
      const fileType = file.name.split('.').pop();
      s3.upload({
        Key: `${this.state.fileCategory}-${Date.now()}.${fileType}`,
        Body: file,
        ACL: 'public-read'
      }, (err, data) => {
        if (err) {
          return AlertJsMessage('There was an error uploading your photo: ', err.message);
        }
        this.props.addFile({
          userId: this.props.user._id || localStorage.id,
          url: data.Location,
          category: this.state.fileCategory,
          fileType: fileType,
          name: file.name
        }).then(() => {
          history.push('/my-media');
        });
      });
    }else{
      AlertJsMessage("No file was uploaded");
    }

  }
  handleFileChange(files){
    const file = files[0];
    if (file) {
      if (acceptTypes[this.state.fileCategory] === 'image/*' ) {
        if (file.size > IMAGE_SIZE_LIMIT_BYTES) {
          AlertJsMessage(`Image is too large. The image you are trying to upload has a size of ${file.size}. The limit for an image upload is ${IMAGE_SIZE_LIMIT_BYTES}. Please upload another image.`);
          this.uploadInput.value = '';
          this.setState({
            ...this.state,
            previewImageSrc: '',
            previewVideoSrc: '',
            fileLoaded: false
          })
        }else{
          this.setState({
            ...this.state,
            previewImageSrc: window.URL.createObjectURL(file),
            fileLoaded: true
          })
        }
      }else if(acceptTypes[this.state.fileCategory] === 'video/mp4'){
        if (file.size > VIDEO_SIZE_LIMIT_BYTES) {
          AlertJsMessage(`Video is too large. The video you are trying to upload has a size of ${file.size}. The limit for a video upload is ${VIDEO_SIZE_LIMIT_BYTES}. Please upload another video.`);
          this.uploadInput.value = '';
          this.setState({
            ...this.state,
            previewImageSrc: '',
            previewVideoSrc: '',
            fileLoaded: false
          })
          return;
        }else{
          this.setState({
            ...this.state,
            previewVideoSrc: window.URL.createObjectURL(file),
            fileLoaded: true
          })
        }

      }
    }else{
      AlertJsMessage("No file selected.");
    }
  }
  handleTypeSelect(e){
    if (e.target.value === 'exercise') {
      AlertJsMessage(EXERCISE_VIDEO_INSTRUCTIONS);
    }
    this.setState({
      ...this.state,
      fileCategory: e.target.value
    })
  }
  render() {
    const { previewImageSrc, previewVideoSrc, isMobile } = this.state;
    return (
      <div className="container">
        <h1>Upload File</h1>

        <select className="form-control" onChange={(e) => this.handleTypeSelect(e)}>
          <option value="profile">Profile Picture</option>
          <option value="explainer">Explainer Video</option>
          <option value="exercise">Exercise Video</option>
        </select>
        <PreviewVideo
          src={previewVideoSrc}
          isMobile={isMobile}
        />
        {
          previewImageSrc ?
          (<img src={previewImageSrc} className='img-fluid' alt="Preview" />) : null
        }
        <br />
        <span>Choose a file to upload to your library.</span>
        <input
          className="form-control"
          onChange={ (e) =>  this.handleFileChange(e.target.files)}
          ref={(ref) => { this.uploadInput = ref; }}
          type="file"
          accept={acceptTypes[this.state.fileCategory]} />
        {
          (this.state.fileLoaded && !this.state.isUploading) ?
          (<button className="btn btn-primary" type="button" onClick={() => this.submit()}> Submit </button>) : null
        }
      </div>

    )
  }
}

export default withRouter(UploadForm);



// WEBPACK FOOTER //
// ./src/components/upload/Form.js